import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col-md-12" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConsulteGrid = _resolveComponent("ConsulteGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConsulteGrid, {
      columns: _ctx.rows,
      "data-source": _ctx.dataSource,
      actions: true,
      onOnChangeDataRow: _ctx.rowChange
    }, {
      nome: _withCtx((context) => [
        _createElementVNode("span", {
          style: _normalizeStyle({ color: _ctx.isUsuarioBloqueado(context.row) ? 'red' : '' })
        }, _toDisplayString(context.row.nome), 5)
      ]),
      tipoUsuario: _withCtx((context) => [
        _createElementVNode("span", {
          style: _normalizeStyle({ color: _ctx.isUsuarioBloqueado(context.row) ? 'red' : '' })
        }, _toDisplayString(context.row.tipoUsuario), 5)
      ]),
      botaoEmprestimo: _withCtx((context) => [
        (!_ctx.isUsuarioBloqueado(context.row))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-outline-warning",
              onClick: ($event: any) => (_ctx.emprestimo(context.row))
            }, " Empréstimos ", 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      botaoReserva: _withCtx((context) => [
        (!_ctx.isUsuarioBloqueado(context.row))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-outline-primary",
              onClick: ($event: any) => (_ctx.reserva(context.row))
            }, " Reserva ", 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "data-source", "onOnChangeDataRow"])
  ]))
}